var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTerminalIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.06409 12.6752L9.96402 2.62H24.0206L21.2145 12.3501C21.1771 12.4796 21.1582 12.6137 21.1582 12.7486V27.4634C21.1582 28.0801 20.6583 28.58 20.0416 28.58H8.17026C7.55361 28.58 7.05371 28.0801 7.05371 27.4634V12.7486C7.05371 12.7237 7.05721 12.699 7.06409 12.6752Z",
    fill: "white",
    stroke: "#1E1E21",
    strokeWidth: 1.46667
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4994 15.6596H10.5519C10.2684 15.6596 10.0386 15.8894 10.0386 16.1729V16.5656C10.0386 16.8491 10.2684 17.079 10.5519 17.079H13.4994C13.7829 17.079 14.0128 16.8491 14.0128 16.5656V16.1729C14.0128 15.8894 13.7829 15.6596 13.4994 15.6596Z",
    fill: "#1E1E21"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5284 4.96722H18.934C19.3049 4.96722 19.5763 5.31715 19.4839 5.67641L18.0782 11.1409C18.0136 11.3918 17.7875 11.5673 17.5284 11.5673H10.8781C10.5032 11.5673 10.2312 11.2102 10.3308 10.8488L11.3627 7.10122",
    stroke: "#1E1E21",
    strokeWidth: 1.46667,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4332 6.43335V28.6324H8.2998",
    stroke: "#1E1E21",
    strokeWidth: 1.46667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTerminalIcon);
export default __webpack_public_path__ + "static/media/terminal-icon.66b02b6126e144c63a4a0eb8ac27d3a1.svg";
export { ForwardRef as ReactComponent };